// TODO move to sentry.server.ts
// eslint-disable-next-line canonical/no-restricted-imports
import { addBreadcrumb as addSentryBreadcrumb } from '@sentry/react';
// TODO move to sentry.server.ts
// eslint-disable-next-line canonical/no-restricted-imports
import type { Breadcrumb } from '@sentry/react';
import dedent from 'dedent';

const dedentExtra = (extra: Record<string, unknown>) => {
  return Object.fromEntries(
    Object.entries(extra).map(([key, value]) => [
      key,
      typeof value === 'string' ? dedent(value) : value,
    ]),
  );
};

export const addBreadcrumb = (breadcrumb: Breadcrumb) => {
  const data = breadcrumb.data ? dedentExtra(breadcrumb.data) : undefined;

  addSentryBreadcrumb({
    ...breadcrumb,
    data,
  });
};
